import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { mediaDesktop } from 'utils/responsive';

export default styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 30vw;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.primary.light};
  ${mediaDesktop(css`
    width: 6vw;
  `)}
`;
